"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRecoverableCode = void 0;
function isRecoverableCode(code) {
    return [401].every(function (unrecoverableStatus) { return unrecoverableStatus !== code; });
}
exports.isRecoverableCode = isRecoverableCode;
//# sourceMappingURL=unrecoverable.js.map